import React, { useEffect, useState } from "react";

import { Tabs as ChakraUiTabs } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";
import { Maybe } from "utils/general/maybe";

import { chakraUiTabsListCss, chakraUiTabsTriggerCss } from "./styles";
import { ITabsProps } from "./types";

export const Tabs = (props: ITabsProps) => {
  const {
    headers,
    contentList,
    renderTabNavAsLink,
    tabsRootWrapperCss,
    tabsHeaderCss,
    tabsHeaderContentCss,
    tabsListHeaderCss,
    tabsContentWrapperCss,
    tabsContentCss,
    tabsHeaderContent,
    onTabChange,
    defaultTabValue,
    renderTabContentOnActiveAndNotWhenTabsComponentMount,
  } = props;
  const [{ value: firsTabHeaderValue }] = headers;
  const [currentTabValue, setCurrentTabValue] = useState(
    defaultTabValue ?? firsTabHeaderValue
  );

  useEffect(() => {
    if (!defaultTabValue) return;
    setCurrentTabValue(defaultTabValue);
  }, [defaultTabValue]);

  return (
    <div>
      <ChakraUiTabs.Root
        defaultValue={defaultTabValue ?? firsTabHeaderValue}
        colorPalette="ep"
        onValueChange={(evt) => {
          const { value } = evt;
          setCurrentTabValue(value);
          if (onTabChange) {
            onTabChange(value);
          }
        }}
        css={tabsRootWrapperCss}
        value={currentTabValue}
      >
        <ChakraUiTabs.List css={{ ...chakraUiTabsListCss, ...tabsHeaderCss }}>
          <Box
            className="flex gap-6"
            css={tabsListHeaderCss}
          >
            {headers.map(({ value, content, isDisabled }, index) => (
              <ChakraUiTabs.Trigger
                key={index}
                value={value}
                asChild={renderTabNavAsLink}
                css={{
                  ...chakraUiTabsTriggerCss,
                  color: currentTabValue === value ? "#00535C" : "#667085",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                }}
                disabled={isDisabled}
              >
                {content}
              </ChakraUiTabs.Trigger>
            ))}
          </Box>
          <Box css={tabsHeaderContentCss}>{tabsHeaderContent}</Box>
        </ChakraUiTabs.List>

        <Box css={tabsContentWrapperCss}>
          {contentList.map(({ value, content }, index) => (
            <Maybe
              condition={
                renderTabContentOnActiveAndNotWhenTabsComponentMount
                  ? value === currentTabValue
                  : true
              }
              key={index}
            >
              <ChakraUiTabs.Content
                value={value}
                css={tabsContentCss}
              >
                {content}
              </ChakraUiTabs.Content>
            </Maybe>
          ))}
        </Box>
      </ChakraUiTabs.Root>
    </div>
  );
};
